/**
 * PDP color swatch → GTM dataLayer (color_swatch_switch)
 */
(function () {
  'use strict';

  let lastPushAt = 0;

  function pushFromLink(link) {
    if (!link) return null;

    const now = Date.now();
    if (now - lastPushAt < 150) return null;
    lastPushAt = now;

    const container =
      link.closest('.color-swatches') ||
      link.closest('.swatches-conatainer') ||
      link.closest('.pdp_color_variant') ||
      link.closest('.swatch-container');

    const productInfo = document.querySelector('product-info');

    const payload = {
      event: 'color_swatch_switch',
      from_product_id:
        (container && container.getAttribute('data-from-product-id')) ||
        (productInfo && productInfo.getAttribute('data-product-id')) ||
        '',
      from_product_handle:
        (container && container.getAttribute('data-from-product-handle')) ||
        (productInfo && productInfo.getAttribute('data-product-handle')) ||
        '',
      from_product_name:
        (container && container.getAttribute('data-from-product-title')) ||
        (productInfo && productInfo.getAttribute('data-product-title')) ||
        '',
      to_product_id: link.getAttribute('data-product-id') || '',
      to_product_handle: link.getAttribute('data-product-handle') || '',
      to_product_name: link.getAttribute('data-product-title') || '',
      to_product_url: link.getAttribute('data-product-url') || link.href || '',
      position: link.getAttribute('data-swatch-position') || '',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      const serialized = JSON.stringify(payload);
      sessionStorage.setItem('last_color_swatch_gtm', serialized);
      sessionStorage.setItem('pending_color_swatch_gtm', serialized);
    } catch (err) {
      /* ignore */
    }

    return payload;
  }

  /** Re-push on next page so dataLayer.filter() works after navigation (for QA + GTM). */
  function flushPendingColorSwatchToDataLayer() {
    try {
      const raw = sessionStorage.getItem('pending_color_swatch_gtm');
      if (!raw) return null;

      sessionStorage.removeItem('pending_color_swatch_gtm');
      const payload = JSON.parse(raw);
      if (!payload || payload.event !== 'color_swatch_switch') return null;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      return payload;
    } catch (err) {
      return null;
    }
  }

  function navigateToLink(link) {
    const href = link.href;
    if (!href || href.toLowerCase().indexOf('javascript') === 0) return;
    setTimeout(() => {
      window.location.assign(href);
    }, 500);
  }

  window.onColorSwatchGtmClick = function (event, link) {
    if (!link) return true;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    pushFromLink(link);
    navigateToLink(link);
    return false;
  };

  window.pushColorSwatchGtm = pushFromLink;
  window.handleColorSwatchGtm = pushFromLink;

  window.getLastColorSwatchEvent = function () {
    const layer = window.dataLayer || [];
    for (let i = layer.length - 1; i >= 0; i -= 1) {
      if (layer[i] && layer[i].event === 'color_swatch_switch') {
        return layer[i];
      }
    }
    try {
      return JSON.parse(sessionStorage.getItem('last_color_swatch_gtm'));
    } catch (err) {
      return null;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[data-gtm-color-swatch]');
      if (!link) return;
      window.onColorSwatchGtmClick(event, link);
    },
    true
  );

  flushPendingColorSwatchToDataLayer();
})();
